import { PassedIcon, FailedIcon } from '../../../../exam/completed/components';

import { type ExamPreviewResultVariant } from './types';

export const EXAM_RESULT_ICON_VARIANT_MAP: Record<ExamPreviewResultVariant, React.ComponentType> = {
  passed: PassedIcon,
  failed: FailedIcon,
};

export const EXAM_RESULT_TITLE_VARIANT_MAP: Record<ExamPreviewResultVariant, string> = {
  passed: 'examPreviewResultCard.result.passed',
  failed: 'examPreviewResultCard.result.failed',
};
